import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = ['customer-number', accountNumber] as const

export type fwdnCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const fwdnDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const fwdn: CarrierDef<fwdnCredType> = {
  name: 'Forward Air',
  scac: 'fwdn',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['account-number', 'ref1'],
    ['customer-number', 'ref2'],
  ],
  engineLayers: ['rating', 'pickup', 'profinder', 'tracking', 'documents'],
  documentTypes: fwdnDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
